<template>
  <a :href="link" target="_blank" class="media box" :class="colorClass">
    <figure class="media-left">
      <p class="image is-32x32">
        <img :src="icon" :alt="`Icon ${title}`" />
      </p>
    </figure>
    <div class="media-content">
      <div class="content">
        <h2 class="title">{{ title }}</h2>
      </div>
      <div class="field">
        <ul class="has-text-white">
          <li><i class="fas fa-tags" /> {{ tags }}</li>
        </ul>
      </div>
    </div>
    <div class="media-right">
      <slot class="delete" />
    </div>
  </a>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      default: "https://green-conseil.com/"
    },
    title: {
      type: String,
      default: "APP"
    },
    tags: {
      type: String,
      default: "GREEN APP"
    },
    color: {
      type: String,
      defaul: "black",
      validator(value) {
        return (
          [
            "white",
            "black",
            "light",
            "dark",
            "primary",
            "info",
            "link",
            "success",
            "warning",
            "danger",
            "grey",
            "teal",
            "red-dark"
          ].indexOf(value) !== -1
        );
      }
    },
    icon: {
      type: String,
      default:
        "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
    }
  },
  computed: {
    colorClass() {
      return `has-background-${this.color}`;
    }
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
}
</style>
